(function () {
  'use strict';

  function boot() {

  var root = document.querySelector('[data-cr]');
  if (!root) return;
  if (root.dataset.crReady === '1') return;
  root.dataset.crReady = '1';

  var STORE_KEY = 'cr-unselected';
  var form = root.querySelector('[data-cr-form]');
  var itemsWrap = root.querySelector('[data-cr-items]');
  var allBox = root.querySelector('[data-cr-all]');
  var selCount = root.querySelector('[data-cr-selcount]');
  var selTotal = root.querySelector('[data-cr-seltotal]');
  var checkoutBtns = Array.prototype.slice.call(root.querySelectorAll('[data-cr-checkout]'));
  var checkoutBtn = checkoutBtns[0] || null;
  var stickyTotal = root.querySelector('[data-cr-stickytotal]');
  var codeInput = root.querySelector('[data-cr-code]');
  var codeBtn = root.querySelector('[data-cr-apply]');
  var codeMsg = root.querySelector('[data-cr-codemsg]');
  var codeClear = root.querySelector('[data-cr-code-clear]');
  var couponToggle = root.querySelector('[data-cr-coupon-toggle]');
  var couponBody = root.querySelector('[data-cr-coupon-body]');
  var codeList = root.querySelector('[data-cr-codelist]');
  var moneyFormat = null;

  function items() {
    return Array.prototype.slice.call(root.querySelectorAll('[data-cr-line]'));
  }

  /* ---------------------------------------------------------------- storage */

  function readUnselected() {
    try {
      var raw = sessionStorage.getItem(STORE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }
  function writeUnselected(list) {
    try {
      sessionStorage.setItem(STORE_KEY, JSON.stringify(list));
    } catch (e) {}
  }

  /* ------------------------------------------------------------------ money */

  function fetchMoneyFormat() {
    if (moneyFormat) return Promise.resolve(moneyFormat);
    return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', {
      headers: { Accept: 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (c) { return c; })
      .catch(function () { return null; });
  }

  /* Money formatting.

     This used to copy the currency shape off the "(QR 2,690.00)" text in the
     old select bar. That element is gone, so the sample came back empty and
     every locally-painted figure lost its "QR" until the server response
     landed. The shop's own money format is read from the section instead, with
     a rendered price on the page as a fallback. */
  var moneyFormatStr = (root.getAttribute('data-money-format') || '').trim();

  function moneyParts(cents, precision, thousands, decimal) {
    precision = precision == null ? 2 : precision;
    thousands = thousands == null ? ',' : thousands;
    decimal = decimal == null ? '.' : decimal;

    if (isNaN(cents) || cents == null) cents = 0;

    var value = (cents / 100.0).toFixed(precision);
    var parts = value.split('.');
    var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    return whole + (parts[1] ? decimal + parts[1] : '');
  }

  var moneyPlaceholder = /\{\{\s*(\w+)\s*\}\}/;

  function formatMoney(cents) {
    if (moneyFormatStr && moneyPlaceholder.test(moneyFormatStr)) {
      var key = moneyFormatStr.match(moneyPlaceholder)[1];
      var out;
      switch (key) {
        case 'amount_no_decimals':
          out = moneyParts(cents, 0);
          break;
        case 'amount_with_comma_separator':
          out = moneyParts(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          out = moneyParts(cents, 0, '.', ',');
          break;
        case 'amount_with_apostrophe_separator':
          out = moneyParts(cents, 2, "'", '.');
          break;
        case 'amount_no_decimals_with_space_separator':
          out = moneyParts(cents, 0, ' ', '');
          break;
        case 'amount_with_space_separator':
          out = moneyParts(cents, 2, ' ', ',');
          break;
        default:
          out = moneyParts(cents, 2);
      }
      return moneyFormatStr.replace(moneyPlaceholder, out);
    }

    /* Last resort: mirror whatever a price already on the page looks like. */
    var shown = root.querySelector('.cr__price, .cr__total, .cr__subtotal');
    var sample = shown ? shown.textContent.trim() : '';
    var num = /[\d.,]+/;
    var joined = moneyParts(cents, 2);
    if (sample && num.test(sample)) return sample.replace(num, joined);
    return joined;
  }

  /* ----------------------------------------------------------------- render */

  function sync() {
    var rows = items();
    var total = 0;
    var selected = 0;
    var unselected = [];

    rows.forEach(function (row) {
      var box = row.querySelector('[data-cr-item]');
      var on = box ? box.checked : true;
      row.classList.toggle('is--unselected', !on);
      if (on) {
        selected++;
        total += parseInt(row.getAttribute('data-cr-total') || '0', 10);
      } else {
        unselected.push(row.getAttribute('data-cr-key'));
      }
    });

    writeUnselected(unselected);

    if (selCount) selCount.textContent = String(selected);
    if (selTotal) selTotal.textContent = '(' + formatMoney(total) + ')';

    if (allBox) {
      allBox.checked = selected === rows.length && rows.length > 0;
      allBox.indeterminate = selected > 0 && selected < rows.length;
    }
    if (stickyTotal) stickyTotal.textContent = formatMoney(total);
    checkoutBtns.forEach(function (b) { b.disabled = selected === 0; });
  }

  /* Restore selection after a cart re-render */
  (function restore() {
    var saved = readUnselected();
    if (!saved.length) { sync(); return; }
    items().forEach(function (row) {
      if (saved.indexOf(row.getAttribute('data-cr-key')) !== -1) {
        var box = row.querySelector('[data-cr-item]');
        if (box) box.checked = false;
      }
    });
    sync();
  })();

  root.addEventListener('change', function (e) {
    if (e.target.matches('[data-cr-item]')) sync();
    if (e.target.matches('[data-cr-all]')) {
      var on = e.target.checked;
      items().forEach(function (row) {
        var box = row.querySelector('[data-cr-item]');
        if (box) box.checked = on;
      });
      sync();
    }
  });

  /* -------------------------------------------------------------- quantity */

  function changeLine(line, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(function (r) { return r.json(); });
  }

  /* Stock ceiling.

     /cart/change.js answers 200 with the quantity Shopify was actually able
     to set, so asking for 10 of a product with 4 left comes back as 4 with no
     error field. Comparing what was asked for with what came back is the only
     way to know, and without it the number silently snapped back with no
     explanation. */
  function showLineError(row, text) {
    var box = row.querySelector('[data-cr-lineerr]');
    if (!box) return;
    var slot = box.querySelector('[data-cr-lineerrtext]');
    if (slot) slot.textContent = text;
    box.hidden = false;
  }

  function clearLineError(row) {
    var box = row.querySelector('[data-cr-lineerr]');
    if (box) box.hidden = true;
  }

  /* The ceiling for a line, once the cart has told us what it is. Shopify does
     not expose inventory to the storefront, so the limit can only be learnt
     from a refused change — but once known it is enforced here rather than
     letting the shopper keep clicking into a rejection. */
  function setLineMax(row, max) {
    if (!row || !max || max < 0) return;
    row.setAttribute('data-cr-max', String(max));
    var input = row.querySelector('[data-cr-qtyinput]');
    if (input) input.max = max;
    syncStepper(row);
  }

  function lineMax(row) {
    var v = parseInt(row.getAttribute('data-cr-max'), 10);
    return isNaN(v) ? null : v;
  }

  function syncStepper(row) {
    var max = lineMax(row);
    var input = row.querySelector('[data-cr-qtyinput]');
    var plus = row.querySelector('[data-cr-step="1"]');
    if (!plus || !input) return;

    var qty = parseInt(input.value, 10) || 0;
    var atMax = max !== null && qty >= max;

    plus.disabled = atMax;
    plus.classList.toggle('is--max', atMax);
    plus.setAttribute('aria-disabled', atMax ? 'true' : 'false');
  }

  function reportStock(row, wanted, cart) {
    var line = parseInt(row.getAttribute('data-cr-line'), 10);
    var tpl = root.getAttribute('data-msg-stock') || 'Only __N__ items are available.';

    /* Two shapes come back depending on how Shopify refuses the quantity:
       a 200 with the quantity silently clamped, or a 422 carrying a
       description and no items array. Only handling the first meant the 422
       case showed nothing at all. */
    if (cart && (cart.status === 422 || cart.description || cart.message)) {
      var avail = null;
      var text = cart.description || cart.message || '';
      var m = text.match(/(\d+)/);
      if (m) avail = parseInt(m[1], 10);

      if (avail !== null) setLineMax(row, avail);
      showLineError(row, avail === null ? text : tpl.replace('__N__', avail));

      /* Snap the field back to what the cart actually holds. */
      return fetch('/cart.js', { cache: 'no-store', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (real) {
          var it = real.items ? real.items[line - 1] : null;
          if (!it) return;
          var input = row.querySelector('[data-cr-qtyinput]');
          if (input) input.value = it.quantity;
          paintLine(row, it.quantity);
        })
        .catch(function () {});
    }

    var item = cart && cart.items ? cart.items[line - 1] : null;
    if (!item) return;

    var got = item.quantity;
    if (got >= wanted) {
      clearLineError(row);
      syncStepper(row);
      return;
    }

    setLineMax(row, got);
    showLineError(row, tpl.replace('__N__', got));

    var field = row.querySelector('[data-cr-qtyinput]');
    if (field) field.value = got;
    paintLine(row, got);
  }

  /* Re-render only this section through the Section Rendering API, then
     re-bind. Keeps scroll position, the wishlist carousel and the gift-wrap
     modal intact — a full reload threw all three away. */
  /* A quantity change only moves numbers: the totals, the delivery bar, the
     line prices and any discount lines. Replacing the whole section for that
     tears down and rebuilds every node, which is the blank flash. The regions
     that actually carry numbers are swapped instead, and the full replace is
     kept for the cases where the structure really changed (a line removed,
     the cart emptied). */
  /* Narrow on purpose. Swapping the whole .cr__right column replaced the
     coupon card with it, and its toggle / input / apply button are bound
     directly rather than by delegation — the new nodes carried no listeners,
     so "Coupons & Offers" stopped opening. Only the blocks that actually hold
     figures are patched, and the coupon card is left alone. */
  var PATCH_REGIONS = [
    '.cr__summary',
    '.fsb-host',
    '.cr__stickybar',
    '.cr__linediscounts',
    '.cr__prices'
  ];

  function lineKeys(scope) {
    return Array.prototype.map
      .call(scope.querySelectorAll('[data-cr-line]'), function (el) {
        return el.getAttribute('data-cr-key');
      })
      .join('|');
  }

  function patchSection(fresh) {
    if (lineKeys(root) !== lineKeys(fresh)) return false;

    for (var i = 0; i < PATCH_REGIONS.length; i += 1) {
      var live = root.querySelectorAll(PATCH_REGIONS[i]);
      var next = fresh.querySelectorAll(PATCH_REGIONS[i]);
      if (live.length !== next.length) return false;
      for (var j = 0; j < live.length; j += 1) {
        if (live[j].innerHTML !== next[j].innerHTML) live[j].innerHTML = next[j].innerHTML;
      }
    }

    /* Quantities Shopify may have clamped (stock limits). */
    var liveQ = root.querySelectorAll('[data-cr-qtyinput]');
    var nextQ = fresh.querySelectorAll('[data-cr-qtyinput]');
    if (liveQ.length === nextQ.length) {
      for (var k = 0; k < liveQ.length; k += 1) {
        if (document.activeElement !== liveQ[k] && liveQ[k].value !== nextQ[k].value) {
          liveQ[k].value = nextQ[k].value;
        }
      }
    }

    /* The applied-code chips sit inside the untouched coupon card, so they
       are refreshed from their own renderer rather than by swapping markup. */
    if (typeof renderAppliedCodes === 'function') {
      try { renderAppliedCodes(); } catch (err) {}
    }

    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    return true;
  }

  function refreshSection() {
    var id = root.getAttribute('data-section-id');
    if (!id) { window.location.reload(); return Promise.resolve(); }
    return fetch(window.location.pathname + '?section_id=' + encodeURIComponent(id))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cr]');
        if (!fresh) return;
        if (patchSection(fresh)) return;
        root.replaceWith(fresh);
        document.dispatchEvent(new CustomEvent('cart:section-refreshed', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      })
      .catch(function () {});
  }

  function refreshCartChrome() {
    return fetch('/?sections=cart-icon-bubble,cart-icon-quick', { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var parser = new DOMParser();

        ['cart-icon-bubble', 'cart-icon-quick'].forEach(function (name) {
          if (!sections[name]) return;
          var doc = parser.parseFromString(sections[name], 'text/html');

          /* The Section Rendering API wraps the section in
             #shopify-section-<name>. The section's own root is a plain div, so
             looking for #<name> inside the response never matched and the
             badge silently kept its old count. */
          var wrapper = doc.querySelector('#shopify-section-' + name);
          var html = wrapper ? wrapper.innerHTML : doc.body.innerHTML;
          if (!html) return;

          document.querySelectorAll('#' + name).forEach(function (el) {
            el.innerHTML = html;
          });
        });
      })
      .catch(function () {})
      .then(function () {
        /* Belt and braces: write the count straight from the cart in case the
           header markup differs from the section snippet. */
        return fetch('/cart.js', { cache: 'no-store', headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var n = cart.item_count;

            document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"], [data-cart-count]')
              .forEach(function (el) { el.textContent = n; });

            document.querySelectorAll('.cart-count-bubble').forEach(function (el) {
              el.classList.toggle('is--empty', n === 0);
            });

            var drawer = document.querySelector('cart-drawer');
            if (drawer) drawer.classList.toggle('is-empty', n === 0);

            document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true }));
          })
          .catch(function () {});
      });
  }

  /* ------------------------------------------------------- live line total

     The row total is repainted from the unit price the moment the stepper is
     used, so the figure never lags the number beside it. The server response
     then re-renders the section with the same values. */
  function paintLine(row, qty) {
    if (!row || !(qty > 0)) return;
    var box = row.querySelector('[data-cr-lineprice]');
    if (!box) return;

    var unit = parseInt(box.getAttribute('data-unit-final'), 10) || 0;
    var comp = parseInt(box.getAttribute('data-unit-compare'), 10) || 0;

    var now = box.querySelector('.cr__price');
    var was = box.querySelector('.cr__mrp');

    if (now) now.textContent = formatMoney(unit * qty);
    if (was && comp > 0) was.textContent = formatMoney(comp * qty);

    /* Keep the cart-level figures in step with the rows. */
    row.setAttribute('data-cr-total', String(unit * qty));
    row.setAttribute('data-cr-qty', String(qty));
    sync();
  }

  /* The old flow blocked on every tap: POST, then a full section re-render
     plus a chrome refresh, with the stepper disabled throughout. Tapping + a
     few times queued that whole round trip each time.

     Now the row repaints locally, the POST is coalesced so only the final
     quantity is sent, and the section re-render happens once at the end. */
  var qtyTimers = {};

  function applyQty(row, qty) {
    paintLine(row, qty);

    var line = parseInt(row.getAttribute('data-cr-line'), 10);
    clearTimeout(qtyTimers[line]);

    clearLineError(row);

    qtyTimers[line] = setTimeout(function () {
      changeLine(line, qty)
        .then(function (cart) {
          return Promise.resolve(reportStock(row, qty, cart)).then(function () {
            var note = row.querySelector('[data-cr-lineerr]');
            var keep = note && !note.hidden ? note.cloneNode(true) : null;

            return Promise.all([refreshSection(), refreshCartChrome()]).then(function () {
              /* A full re-render would drop the notice, so it is put back on
                 the matching row afterwards. */
              if (!keep) return;
              var again = document.querySelector(
                '[data-cr-line="' + row.getAttribute('data-cr-line') + '"] [data-cr-lineerr]'
              );
              if (again) again.replaceWith(keep);
            });
          });
        })
        .catch(function () {})
        .then(function () {});
    }, 400);

    return Promise.resolve();
  }

  /* The cap is rendered by Liquid from variant.inventory_quantity, so the +
     is already correct on first paint — waiting for a refusal meant the very
     first run let the shopper climb past the limit. */
  function syncAllSteppers() {
    root.querySelectorAll('[data-cr-line]').forEach(syncStepper);
  }

  /* Sticky only makes sense while the summary is shorter than the viewport.
     Once the cards add up to more than that, the pinned top hides its own
     bottom and every scroll-up jerks against the stick. */
  function syncStickyColumn() {
    var col = root.querySelector('.cr__right');
    if (!col) return;

    col.classList.remove('is--tall');
    var fits = col.getBoundingClientRect().height + 40 <= window.innerHeight;
    col.classList.toggle('is--tall', !fits);
  }

  var stickyTimer;
  function syncStickySoon() {
    clearTimeout(stickyTimer);
    stickyTimer = setTimeout(syncStickyColumn, 120);
  }

  syncStickyColumn();
  window.addEventListener('resize', syncStickySoon);
  document.addEventListener('cart:section-refreshed', syncStickySoon);

  if (window.ResizeObserver) {
    var col = root.querySelector('.cr__right');
    if (col) new ResizeObserver(syncStickySoon).observe(col);
  }

  syncAllSteppers();
  document.addEventListener('cart:section-refreshed', syncAllSteppers);

  root.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cr-step]');
    if (!btn) return;
    e.preventDefault();
    var wrap = btn.closest('.cr__qty');
    var input = wrap.querySelector('[data-cr-qtyinput]');
    var row = btn.closest('[data-cr-line]');
    var step = parseInt(btn.getAttribute('data-cr-step'), 10);
    var current = parseInt(input.value, 10) || 0;
    var next = current + step;
    if (next < 0) next = 0;

    var max = lineMax(row);
    if (max !== null && next > max) {
      /* Already at the ceiling: say so and leave the number alone, instead of
         counting up and snapping back a moment later. */
      var tpl = root.getAttribute('data-msg-stock') || 'Only __N__ items are available.';
      showLineError(row, tpl.replace('__N__', max));
      input.value = max;
      syncStepper(row);
      return;
    }

    input.value = next;
    syncStepper(row);
    applyQty(row, next);
  });

  root.addEventListener('change', function (e) {
    if (!e.target.matches('[data-cr-qtyinput]')) return;
    var row = e.target.closest('[data-cr-line]');
    var qty = parseInt(e.target.value, 10);
    if (isNaN(qty) || qty < 0) qty = 0;

    var cap = lineMax(row);
    if (cap !== null && qty > cap) {
      var msg = root.getAttribute('data-msg-stock') || 'Only __N__ items are available.';
      showLineError(row, msg.replace('__N__', cap));
      qty = cap;
      e.target.value = cap;
    }

    syncStepper(row);
    applyQty(row, qty);
  });

  /* ------------------------------------------------------------ bulk action */

  function removeKeys(keys) {
    if (!keys.length) return Promise.resolve();
    var updates = {};
    keys.forEach(function (k) { updates[k] = 0; });
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function (r) { return r.json(); });
  }

  var removeSel = root.querySelector('[data-cr-removesel]');
  if (removeSel) {
    removeSel.addEventListener('click', function () {
      /* Clear Cart: every line, no selection to consult. */
      var keys = items().map(function (row) { return row.getAttribute('data-cr-key'); });
      if (!keys.length) return;
      removeSel.disabled = true;
      removeKeys(keys).then(function () {
        writeUnselected([]);
        refreshSection();
        refreshCartChrome();
      });
    });
  }

  var wishBtn = root.querySelector('[data-cr-wishlist]');
  if (wishBtn) {
    wishBtn.addEventListener('click', function () {
      /* Move all to Wishlist: every line. */
      var rows = items();
      if (!rows.length) return;

      /* window.WishlistStorage is the theme's own localStorage wishlist
         (assets/wishlist.js). It takes the same object shape the heart buttons
         build from their data- attributes, so the line carries those already. */
      var store = window.WishlistStorage;
      if (!store || typeof store.add !== 'function') return;

      rows.forEach(function (row) {
        try {
          store.add({
            id: row.getAttribute('data-product-id'),
            handle: row.getAttribute('data-handle') || '',
            title: row.getAttribute('data-title') || '',
            image: row.getAttribute('data-image') || '',
            price: row.getAttribute('data-price') || '',
            variantId: row.getAttribute('data-variant-id') || '',
            variantTitle: row.getAttribute('data-variant-title') || ''
          });
        } catch (err) {}
      });

      if (window.WishlistUI) {
        try {
          window.WishlistUI.updateBadge();
          window.WishlistUI.updateAllButtons();
        } catch (err) {}
      }

      /* The carousel renders from localStorage, and a same-tab write never
         fires the storage event — tell it directly. */
      document.dispatchEvent(new CustomEvent('cart:wishlist-updated', { bubbles: true }));

      wishBtn.disabled = true;
      removeKeys(rows.map(function (row) { return row.getAttribute('data-cr-key'); }))
        .then(function () {
          writeUnselected([]);
          refreshSection();
          refreshCartChrome();
          document.dispatchEvent(new CustomEvent('cart:wishlist-updated', { bubbles: true }));
        });
    });
  }

  /* Per-row heart: saves the line to the wishlist and takes it out of the
     cart, the same trade the bulk button makes. */
  root.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cr-itemwish]');
    if (!btn) return;
    e.preventDefault();

    var row = btn.closest('[data-cr-line]');
    if (!row) return;

    var store = window.WishlistStorage;
    if (store && typeof store.add === 'function') {
      try {
        store.add({
          id: row.getAttribute('data-product-id'),
          handle: row.getAttribute('data-handle') || '',
          title: row.getAttribute('data-title') || '',
          image: row.getAttribute('data-image') || '',
          price: row.getAttribute('data-price') || '',
          variantId: row.getAttribute('data-variant-id') || '',
          variantTitle: row.getAttribute('data-variant-title') || ''
        });
      } catch (err) {}
    }

    if (window.WishlistUI) {
      try {
        window.WishlistUI.updateBadge();
        window.WishlistUI.updateAllButtons();
      } catch (err) {}
    }
    document.dispatchEvent(new CustomEvent('cart:wishlist-updated', { bubbles: true }));

    btn.disabled = true;
    removeKeys([row.getAttribute('data-cr-key')]).then(function () {
      refreshSection();
      refreshCartChrome();
      document.dispatchEvent(new CustomEvent('cart:wishlist-updated', { bubbles: true }));
    });
  });

  /* ----------------------------------------------------------- discount code */

  function currentCodes() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var out = [];
        (c.cart_level_discount_applications || []).forEach(function (d) {
          if (d.type === 'discount_code' && d.title) out.push(d.title);
        });
        return out;
      })
      .catch(function () { return []; });
  }

  function clearCodeError() {
    if (codeMsg) { codeMsg.hidden = true; codeMsg.className = 'cr__codemsg'; codeMsg.textContent = ''; }
    if (codeInput) {
      codeInput.classList.remove('is--err');
      var f = codeInput.closest('.cr__codeform');
      if (f) f.classList.remove('is--err');
    }
  }

  function showCodeError(text) {
    if (codeInput) {
      codeInput.classList.add('is--err');
      var fe = codeInput.closest('.cr__codeform');
      if (fe) fe.classList.add('is--err');
    }
    if (!codeMsg) return;
    codeMsg.textContent = text;
    codeMsg.className = 'cr__codemsg is--err';
    codeMsg.hidden = false;
  }

  function syncClearBtn() {
    if (!codeClear || !codeInput) return;
    codeClear.hidden = codeInput.value.trim().length === 0;
  }

  /* An automatic discount is applied by Shopify itself and has no code to
     enter. It shows up in the cart's discount applications by title, so if the
     shopper types its name we can say "already applied" instead of letting
     Shopify reject it as an unknown code. */
  function discountTitleOnCart(cart, want) {
    function titleMatches(d) {
      return d && (d.title || '').toUpperCase() === want;
    }

    if ((cart.cart_level_discount_applications || []).some(titleMatches)) return true;

    return (cart.items || []).some(function (item) {
      if ((item.discounts || []).some(titleMatches)) return true;
      return (item.line_level_discount_allocations || []).some(function (a) {
        return titleMatches(a && a.discount_application);
      });
    });
  }

  function showCodeNote(text) {
    if (!codeMsg) return;
    if (codeInput) {
      codeInput.classList.remove('is--err');
      var fn = codeInput.closest('.cr__codeform');
      if (fn) fn.classList.remove('is--err');
    }
    codeMsg.textContent = text;
    codeMsg.className = 'cr__codemsg is--note';
    codeMsg.hidden = false;
  }

  function msgFor(name, fallback) {
    var el = root.querySelector('[data-cr-coupon]');
    return (el && el.getAttribute(name)) || fallback;
  }

  function applyCode(code) {
    if (!code) return;
    clearCodeError();
    if (codeBtn) codeBtn.disabled = true;

    fetch('/cart.js', { cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (discountTitleOnCart(cart, code.toUpperCase())) {
          showCodeNote(msgFor('data-msg-already', 'This discount is already applied to your cart.'));
          if (codeBtn) codeBtn.disabled = false;
          return null;
        }
        return true;
      })
      .then(function (go) {
        if (!go) return null;
        return currentCodes();
      })
      .then(function (existing) {
      if (!existing) return null;
      var list = existing.slice();
      if (list.indexOf(code) === -1) list.push(code);
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: list.join(',') })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var want = code.toUpperCase();

          /* cart.discount_codes carries an `applicable` flag and is the
             authoritative answer. Trust it whenever Shopify sends it. */
          var echoed = (cart.discount_codes || []).filter(function (d) {
            return (d.code || '').toUpperCase() === want;
          })[0];

          if (echoed && echoed.applicable === true) {
            rememberCouponOpen(true);
            if (codeInput) codeInput.value = '';
            syncClearBtn();
            renderAppliedCodes();
            refreshSection();
            refreshCartChrome();
            return;
          }

          /* Fallback for responses without that array: a code can land on the
             cart total OR on individual lines. A product-scoped code such as
             SUMMER10 only ever shows up in the line-level allocations, so
             checking cart_level_discount_applications alone reports a
             successful discount as a failure. */
          function titleMatches(d) {
            return d && (d.title || '').toUpperCase() === want;
          }

          var appliedCartLevel = (cart.cart_level_discount_applications || []).some(titleMatches);

          var appliedLineLevel = (cart.items || []).some(function (item) {
            var byDiscounts = (item.discounts || []).some(titleMatches);
            var byAllocations = (item.line_level_discount_allocations || []).some(function (a) {
              return titleMatches(a && a.discount_application);
            });
            return byDiscounts || byAllocations;
          });

          if (!echoed && (appliedCartLevel || appliedLineLevel)) {
            refreshSection();
            refreshCartChrome();
            return;
          }

          var el = root.querySelector('[data-cr-coupon]');
          if (appliedCartLevel || appliedLineLevel) {
            showCodeNote(msgFor('data-msg-already', 'This discount is already applied to your cart.'));
            return;
          }

          var msgNotApply = (el && el.getAttribute('data-msg-notapply'))
            || 'This code does not apply on the items in cart.';
          var msgInvalid = (el && el.getAttribute('data-msg-invalid'))
            || 'The code you entered is invalid. Please double-check the code and try again.';

          showCodeError(echoed ? msgNotApply : msgInvalid);
        });
    }).catch(function () {
      showCodeError('Something went wrong. Please try again.');
    }).finally(function () {
      if (codeBtn) codeBtn.disabled = false;
    });
  }

  /* ------------------------------------------------------------------
     Applied codes: render one removable chip per code Shopify reports as
     applicable, so a shopper can take a coupon off again.
     ------------------------------------------------------------------ */
  function renderAppliedCodes() {
    if (!codeList) return;

    fetch('/cart.js', { cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var codes = (cart.discount_codes || []).filter(function (d) {
          return d && d.code && d.applicable !== false;
        });

        codeList.textContent = '';

        if (!codes.length) {
          codeList.hidden = true;
          return;
        }

        /* A code is active — keep the panel open so the chip is visible after
           the section re-renders. */
        setCouponOpen(true, false);

        codes.forEach(function (d) {
          var chip = document.createElement('span');
          chip.className = 'cr__codechip';

          var label = document.createElement('b');
          label.textContent = d.code;
          chip.appendChild(label);

          var rm = document.createElement('button');
          rm.type = 'button';
          rm.className = 'cr__codechip__x';
          rm.setAttribute('data-cr-code-remove', d.code);
          rm.setAttribute('aria-label', 'Remove ' + d.code);
          rm.innerHTML = '<svg viewBox="0 0 20 20" width="14" height="14" aria-hidden="true">'
            + '<path d="M6 6l8 8M14 6l-8 8" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';
          chip.appendChild(rm);

          codeList.appendChild(chip);
        });

        codeList.hidden = false;
      })
      .catch(function () {});
  }

  function removeCode(code) {
    currentCodes().then(function (existing) {
      var list = existing.filter(function (c) {
        return c.toUpperCase() !== code.toUpperCase();
      });
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: list.join(',') })
      }).then(function () {
        refreshSection();
        refreshCartChrome();
      });
    }).catch(function () {});
  }

  if (codeList) {
    codeList.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-cr-code-remove]');
      if (!btn) return;
      removeCode(btn.getAttribute('data-cr-code-remove'));
    });
    renderAppliedCodes();
  }

  /* The section is re-rendered after every cart change, which resets the
     panel to collapsed. Remember the shopper's choice for the session so the
     box does not snap shut under them. */
  var COUPON_OPEN_KEY = 'crCouponOpen';

  function rememberCouponOpen(open) {
    try { sessionStorage.setItem(COUPON_OPEN_KEY, open ? '1' : '0'); } catch (e) {}
  }

  function couponWasOpen() {
    try { return sessionStorage.getItem(COUPON_OPEN_KEY) === '1'; } catch (e) { return false; }
  }

  function setCouponOpen(open, remember) {
    if (!couponToggle || !couponBody) return;
    couponBody.hidden = !open;
    couponToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    var card = root.querySelector('[data-cr-coupon]');
    if (card) card.classList.toggle('is--open', open);
    if (remember) rememberCouponOpen(open);
  }

  if (couponToggle && couponBody) {
    couponToggle.addEventListener('click', function () {
      var open = couponBody.hidden;
      setCouponOpen(open, true);
      if (open && codeInput) codeInput.focus();
    });

    if (couponWasOpen()) setCouponOpen(true, false);
  }

  if (codeClear && codeInput) {
    codeClear.addEventListener('click', function () {
      codeInput.value = '';
      clearCodeError();
      syncClearBtn();
      codeInput.focus();
    });
  }

  if (codeInput) {
    codeInput.addEventListener('input', function () {
      clearCodeError();
      syncClearBtn();
    });
    syncClearBtn();
  }

  if (codeBtn && codeInput) {
    codeBtn.addEventListener('click', function () { applyCode(codeInput.value.trim()); });
    codeInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); applyCode(codeInput.value.trim()); }
    });
  }



  /* -------------------------------------------------------------- checkout */

  if (form && checkoutBtn) {
    form.addEventListener('submit', function (e) {
      /* Nothing is deselectable now, so the form submits as-is. */
      return;
      /* eslint-disable no-unreachable */
      var unselected = [];
      if (!unselected.length) return;

      e.preventDefault();
      checkoutBtns.forEach(function (b) { b.disabled = true; });
      removeKeys(unselected).then(function () {
        writeUnselected([]);
        form.submit();
      });
    });
  }

  }

  /* ==========================================================================
     Summary column pinning

     position: sticky proved unreliable on this storefront: it holds for the
     first scroll then stops, which is what happens when an ancestor picks up
     a transform or a clip part way down the page. Measuring the grid and
     switching the column to position: fixed sidesteps every one of those
     conditions.
     ========================================================================== */
  function initStickySummary() {
    var DESKTOP = 990;
    var grid = document.querySelector('.cr__grid');
    var right = document.querySelector('.cr__right');
    var left = document.querySelector('.cr__left');
    if (!grid || !right || right.dataset.crPinReady === '1') return;
    right.dataset.crPinReady = '1';

    var topGap = 20;
    var bottomGap = 20;
    var pinned = false;
    var natural = null;   // { left, width } measured while unpinned

    function unpin() {
      if (!pinned) return;
      pinned = false;
      right.classList.remove('is-cr-pinned');
      right.style.position = '';
      right.style.top = '';
      right.style.left = '';
      right.style.width = '';
      right.style.maxHeight = '';
      right.style.overflowY = '';
    }

    function measure() {
      var r = right.getBoundingClientRect();
      if (r.width) natural = { left: r.left, width: r.width };
    }

    function update() {
      if (window.innerWidth < DESKTOP) {
        unpin();
        natural = null;
        return;
      }

      if (!pinned) measure();
      if (!natural) return;

      /* Nothing to gain from pinning when the item list is no taller than the
         summary: there is no travel, and a fixed column would just sit still
         while looking like a bug. 24px of slack so a near-match stays static. */
      if (left && left.offsetHeight <= right.offsetHeight + 24) {
        unpin();
        return;
      }

      var gridRect = grid.getBoundingClientRect();
      var height = right.offsetHeight;
      var maxH = window.innerHeight - topGap - bottomGap;

      /* Nothing to pin to yet, or the whole grid has gone past. */
      if (gridRect.top > topGap || gridRect.bottom <= topGap + 60) {
        unpin();
        return;
      }

      /* Ride up with the end of the grid instead of overrunning it. */
      var top = Math.min(topGap, gridRect.bottom - Math.min(height, maxH) - bottomGap);

      right.style.position = 'fixed';
      right.style.top = top + 'px';
      right.style.left = natural.left + 'px';
      right.style.width = natural.width + 'px';
      if (height > maxH) {
        right.style.maxHeight = maxH + 'px';
        right.style.overflowY = 'auto';
      } else {
        right.style.maxHeight = '';
        right.style.overflowY = '';
      }

      if (!pinned) {
        pinned = true;
        right.classList.add('is-cr-pinned');
      }
    }

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        update();
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { unpin(); natural = null; update(); });
    document.addEventListener('cart:section-refreshed', function () { unpin(); natural = null; update(); });
    update();
  }

  boot();
  initStickySummary();
  /* The wishlist carousel replaces this section's markup after adding to cart.
     Re-bind against the fresh DOM instead of forcing a page reload. */
  document.addEventListener('cart:section-refreshed', function () { boot(); initStickySummary(); });
  document.addEventListener('shopify:section:load', function () { boot(); initStickySummary(); });
})();
